import clsx from 'clsx';
import type * as React from 'react';

/**
 * A gradient banner within the card to highlight a card.
 */
export function CardHighlight(
    props: React.ComponentPropsWithoutRef<'div'> & {
        kind?: 'branded' | 'neutral';
    }
) {
    const { kind = 'branded', ...rest } = props;
    return (
        <div
            {...rest}
            className={clsx(
                {
                    neutral: 'border-b bg-[--sp-color-badge-bg-secondary]',
                    branded:
                        'bg-gradient-to-r from-[var(--light-start)] to-[var(--light-end)] dark:from-[var(--dark-start)] dark:to-[var(--dark-end)]',
                }[kind],
                rest.className
            )}
            style={
                {
                    '--light-start': '#ffe1c680',
                    '--light-end': '#f9d9e680',
                    '--dark-start': '#89C6DA80',
                    '--dark-end': '#7F846A80',
                    ...rest.style,
                } as React.CSSProperties
            }
        />
    );
}
